<template>
  <div>
    <el-button
      @click="build()"
      class="w-full"
      type="primary"
      size="large"
    >
      Generate Application</el-button
    >

    <app-builder-require-auth-modal
      v-model="builderRequireAuthModal"
    ></app-builder-require-auth-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'app-builder-generate-button',

  data() {
    return {
      builderRequireAuthModal: false,
    };
  },

  computed: {
    ...mapGetters({
      scaffold: 'scaffold/current',
      authenticated: 'auth/authenticated',
    }),
  },

  methods: {
    doOpenAuthModal() {
      this.builderRequireAuthModal = true;
    },

    async build() {
      if (!this.authenticated) {
        this.doOpenAuthModal();
        return;
      }

      return this.$store.dispatch('builder/build');
    },
  },
};
</script>

<style></style>
